"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@fluentui/react");
var _FeedbackButton = require("../Shared/Components/FeedbackButton/FeedbackButton");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var RepositoryOwnerPanelFooter = function RepositoryOwnerPanelFooter(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "bolt-panel-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "feedback-button"
  }, /*#__PURE__*/React.createElement(_FeedbackButton.FeedbackButton, null)), !props.repoIsExempted && /*#__PURE__*/React.createElement(_react2.Stack, {
    tokens: {
      childrenGap: 8
    },
    className: "btn-group-right",
    horizontal: true
  }, /*#__PURE__*/React.createElement(_react2.DefaultButton, {
    text: t("repositoryOwnerPanel.cancel"),
    id: "repository-owner-panel-cancel-button",
    onClick: props.closePanel
  }), /*#__PURE__*/React.createElement(_react2.PrimaryButton, {
    disabled: props.submitIsDisabled || props.isLoading,
    id: "repository-owner-panel-save-button",
    onClick: props.submitData
  }, props.isSubmitting && /*#__PURE__*/React.createElement(_react2.Spinner, {
    className: "icon-margin",
    size: _react2.SpinnerSize.small
  }), t("repositoryOwnerPanel.save"))));
};
var _default = RepositoryOwnerPanelFooter;
exports.default = _default;